export const CommonRels = {
    getSettings: 'getSettings'
};
